import React from 'react';
import { Link } from 'react-router-dom';
import phoneIcon from '../../assets/images/icon/phone-icon-1.png';
import HeroForm from '../Hero/HeroForm';

function QuoteForm({ cityData, locationInfo }) {

    return (
        <section className="contact-one">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="contact-one__left">
                            <div className="section-title text-left">
                                <span className="section-title__tagline">FREE QUOTE</span>
                                <h2 className="section-title__title">Complete the form to <span>get your free junk removal quote:</span></h2>
                            </div>
                            {/* <p className="contact-one__text">If you need to repair or replace your Plumbing system, call
                                today and talk to one of our Plumbing specialists. They'll answer all your questions and
                                arrange.</p> */}
                                <div className="video-gallery__service-points-box">
                                <ul className="list-unstyled video-gallery__service-points">
                                    <li>
                                        <div className="icon">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="text">
                                            <p>All-inclusive rates</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="text">
                                            <p>Up to 40% cheaper than others</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="text">
                                            <p>No hidden fees, ever!</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="contact-one__phone">
                                <div className="contact-one__phone-img">
                                    <img src={phoneIcon} alt="" />
                                </div>
                                <div className="contact-one__phone-content">
                                    <p>Speak to someone right now, call:</p>
                                    <h4>
                                        <Link to={'tel:'+locationInfo.tracking_phone}>{locationInfo.tracking_phone}</Link>    
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="contact-one__right">
                            <HeroForm
                                cityData={cityData}
                                locationInfo={locationInfo}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default QuoteForm;